import { SectionBox } from "components/v2/SectionBox";
import React, { useEffect, useState } from "react";
import { EntityMetadataManager } from "./EntityMetadataManager";
import { useMutation, useQuery, useQueryClient } from "react-query";
import BackendServiceV2 from "services/v2/BackendService";
import { Checkbox, LoadingOverlay, NumberInput, Stack, Text, TextInput } from "@mantine/core";
import { useDebouncedValue } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import { Check, X } from "tabler-icons-react";
import equal from'fast-deep-equal';

export function EntityMetadata({idEntity, entityClass}) {

    const queryClient = useQueryClient();

    const {data: categories, isLoading: isLoadingCategories} = useQuery(['entity-metadata-list', entityClass], () => {
        return BackendServiceV2.get('/entity/metadata/category?entityClass=' + entityClass);
    });

    const [values, setValues] = useState({});
    const [debouncedValues] = useDebouncedValue(values, 3000);

    const {data: valuesDB, isLoading: isLoadingValues} = useQuery(['entity-metadata-values', entityClass], () => {
        return BackendServiceV2.get('/entity/metadata/value?idEntity=' + idEntity + '&entityClass=' + entityClass);
    });

    useEffect(() => {
        if(valuesDB?.data)
            setValues(valuesDB?.data);
    // eslint-disable-next-line
    }, [valuesDB]);

    useEffect(() => {
        if(!debouncedValues)
            return;

        if(equal(valuesDB?.data, debouncedValues))
            return;

        if(Object.keys(debouncedValues).length === 0)
            return;

        updateMetadata(debouncedValues);
    // eslint-disable-next-line
    }, [debouncedValues])

    const {mutate: updateMetadata, isLoading: isLoadingUpdate} = useMutation(values => {
        let data = {
            idEntity: idEntity,
            entityClass: entityClass,
            data: values
        }
        
        return BackendServiceV2.put('/entity/metadata/value', data);
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries('entity-metadata-values');
            showNotification({
                title: 'Metadados atualizado com sucesso!',
                message: '',
                autoClose: 5000,
                color: 'green',
                icon: <Check />
            });
        },
        onError: (error) => {
            showNotification({
                title: 'Um erro ocorreu',
                message: error?.response?.data?.message,
                autoClose: 5000,
                color: 'red',
                icon: <X />
            });
        }
    })

    return (
        <SectionBox
            title="Metadados"
            right={<EntityMetadataManager entityClass={entityClass} categories={categories} />}
        >
            <LoadingOverlay visible={isLoadingCategories || isLoadingValues || isLoadingUpdate} />

            <Stack style={{width: '100%'}}>
                {categories?.map(category => (
                    <div key={category.id}>    
                        <Text weight="bold">{category.displayName}</Text>
        
                        <Stack mt={10}>
                            {category.metadatas.map(metadata => (
                                <div key={metadata.id}>                                
                                    {metadata.type === 'STRING' &&
                                        <TextInput
                                            label={metadata.displayName}
                                            value={values[metadata.slug] !== undefined ? values[metadata.slug] : ''}
                                            onChange={e => setValues((oldValues) => {
                                                return {...oldValues, [metadata.slug]: e.target.value}
                                            })}
                                        />
                                    }

                                    {metadata.type === 'NUMBER' &&
                                        <NumberInput
                                            label={metadata.displayName}
                                            precision={2}
                                            value={values[metadata.slug]}
                                            onChange={value => setValues((oldValues) => {
                                                return {...oldValues, [metadata.slug]: value}
                                            })}
                                        />
                                    }

                                    {metadata.type === 'BOOLEAN' &&
                                        <Checkbox
                                            label={metadata.displayName}
                                            checked={values[metadata.slug]}
                                            onChange={e => setValues((oldValues) => {
                                                return {...oldValues, [metadata.slug]: e.target.checked}
                                            })}
                                        />
                                    }
                                </div>
                            ))}
                        </Stack>
                    </div>
                ))}
            </Stack>
        </SectionBox>
    )
}